// Client-side-only demo validation for the newsletter form(s). Used only
// while no real Contact Form 7 shortcode is set in the Customizer — once one
// is, template-parts/newsletter.php renders that form instead and this
// script finds nothing to bind to. No email is sent.
document.addEventListener("DOMContentLoaded", function () {
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  document.querySelectorAll(".js-newsletter-form").forEach(function (form) {
    var input = form.querySelector('input[type="email"]');
    var msg = form.querySelector("[data-newsletter-msg]");
    if (!input) return;

    form.addEventListener("submit", function (e) {
      e.preventDefault();

      var value = input.value.trim();
      form.classList.remove("is-success", "is-error");

      if (!emailPattern.test(value)) {
        form.classList.add("is-error");
        input.setAttribute("aria-invalid", "true");
        if (msg) {
          msg.textContent = value ? "That email doesn't look right — check it and try again." : "Drop your email address first.";
        }
        input.focus();
        return;
      }

      input.removeAttribute("aria-invalid");
      form.classList.add("is-success");
      if (msg) {
        msg.textContent = "You're in! Your first brief lands tomorrow morning.";
      }
      form.reset();
    });
  });
});
